import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import styles from "./meetings.module.scss";
import Images from "assets/Images";
import UpcomingMeetings from "./upcoming";
import PreviousMeetings from "./previous";
import Dialog from '@mui/material/Dialog';
import ScheduleMeeting from "./scheduleMeeting";
import MeetingMinutes from "./meetingMinutes";
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import { IconButton  } from "@mui/material";

 const meetings=[
    {
      id: 1,
      topic: "Steering Committe Meeting - N7",
      date: "2025-12-26 10:00 AM",
      duration: "10:00 AM - 11:00 AM",
      invitees: ["Sahul Hameed", "James Hawkins"],
      inviteesLink: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/meetings?clientId=attendees&roomId=meetings`,
      organizerLink: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/meetings?clientId=organizer&roomId=meetings`,
      status: "Scheduled",
      meetingId: "818 1986 0368",
    },
    {
      id: 2,
      topic: "Quarterly Review - Q3",
      date: "2025-09-07 02:00 PM",
      duration: "02:00 PM - 03:30 PM",
      invitees: ['Sunil Basker', "Mohan Kumar", "Sahul Hameed"],
      inviteesLink: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/meetings?clientId=attendees&roomId=quarterly-review`,
      organizerLink: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/meetings?clientId=organizer&roomId=quarterly-review`,
      status: "Scheduled",
      meetingId: "975 3241 5612",
    },
    {
      id: 3,
      topic: "Product Roadmap Discussion",
      date: "2025-09-23 11:30 AM",
      duration: "11:30 AM - 12:30 PM",
      invitees: ["Sri Kanth", 'John Smith', "James Hawkins"],
      inviteesLink: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/meetings?clientId=attendees&roomId=product-roadmap`,
      organizerLink: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/meetings?clientId=organizer&roomId=product-roadmap`,
      status: "Scheduled",
      meetingId: "653 1129 8845",
    },
    {
      id: 4,
      topic: "Tech Sync-up",
      date: "2025-09-10 09:00 AM",
      duration: "09:00 AM - 09:45 AM",
      invitees: ['Rakesh Sharma', "Sahul Hameed"],
      inviteesLink: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/meetings?clientId=attendees&roomId=tech-sync`,
      organizerLink: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/meetings?clientId=organizer&roomId=tech-sync`,
      status: "Scheduled",
      meetingId: "842 9937 4471",
    },
    {
      id: 5,
      topic: "Client Presentation - Alpha Project",
      date: "2025-09-15 04:00 PM",
      duration: "04:00 PM - 05:00 PM",
      invitees: ['John Smith', 'Rakesh Sharma'],
      inviteesLink: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/meetings?clientId=attendees&roomId=alpha-project`,
      organizerLink: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/meetings?clientId=organizer&roomId=alpha-project`,
      status: "Scheduled",
      meetingId: "321 7645 2299",
    }
  ]
const ScheduledMeetingList = () => {
  const [value, setValue] = React.useState('1');
  const [openCopyMeetingLink, setOpenCopyMeetingLink] = React.useState(false);
  const [meetingUrl, setMeetingUrl] = useState('');
  const [copied, setCopied] = useState(false);
    const [date, setDate] = React.useState([dayjs(), dayjs().add(7, 'day')]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const Invitees = [
    { title: 'Sahul Hameed' },
    { title: 'James hawkins' },
    { title: 'Sunil Basker' },
    { title: 'Mohan Kumar' },
    { title: 'Rakesh Sharma' },
    { title: "Sri Kanth" },
    { title: 'John Smith' }
  ];
 
   const [meetingsData, setMeetingsData] = useState([]);
  const [previousData, setPreviousData] = useState([]);
    useEffect(() => {
    const now = new Date();

    const upcoming = [];
    const past = [];

    meetings.forEach((m) => {
      // Parse string like "2025-09-07 02:00 PM"
      const meetingDate = new Date(m.date);

      if (meetingDate >= now) {
        upcoming.push(m);
      } else {
        past.push(m);
      }
    });

    setMeetingsData(upcoming);
    setPreviousData(past);
  }, []);
  const [openMeatingMinutes, setOpenMeatingMinutes] = React.useState(false);

  const handleOpenMeatingMinutes = () => {
    setOpenMeatingMinutes(true);
  };

  const handleCloseMeetingMinutes = () => {
    setOpenMeatingMinutes(false);
  };
  const getCustomerLink = (link) => {
    setMeetingUrl(link)
    setOpenCopyMeetingLink(true)
  }
  const handleCloseCopyLink = () => {
    setOpenCopyMeetingLink(false)
  }
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(meetingUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2s
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };
  return (

    <div className={`ScheduledMeetingList ${styles.ScheduledMeetingList}`}>
      <Dialog open={openCopyMeetingLink} onClose={handleCloseCopyLink}>
        <div className={styles.copytoClipboard}>
          <h5>Copy Meeting Link</h5>
          <IconButton
            className={styles.closeIcon}
            aria-label="close"
            onClick={handleCloseCopyLink}
          >
            <img src={Images.CLOSE} alt="Close" width="12" />
          </IconButton>
          <p>{meetingUrl}</p>
          <div className={styles.btnCont}>
            <button onClick={handleCopy}>
              {copied ? "Copied!" : "Copy to Clipboard"}
            </button>
          </div>
        </div>
      </Dialog>
      <Dialog open={open} onClose={handleClose}>
        <ScheduleMeeting handleClose={handleClose} />
      </Dialog>
      <Dialog open={openMeatingMinutes} onClose={handleCloseMeetingMinutes}>
        <MeetingMinutes />
      </Dialog>
      <div className={styles.meetingWrapper}>
        <div className={styles.header}>
          <h3 className="text-lg font-semibold mb-2">Meetings</h3>
          <div className={styles.btnAlign}>
             <div className={`${styles.dateRange} customDateRangePicker`}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateRangePicker
                            value={date}
                            onChange={(newValue) => setDate(newValue)}
                            PopperProps={{
                                        modifiers: [
                                        {
                                            name: "preventOverflow",
                                            options: {
                                            boundary: "viewport", 
                                            padding: 8,
                                            },
                                        },
                                        {
                                            name: "flip",
                                            options: {
                                            fallbackPlacements: ["bottom-end", "top-end"], 
                                            },
                                        },
                                        ],
                                    }}
                            renderInput={(startProps, endProps) => (
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <TextField {...startProps} label="Start date" />
                                <TextField {...endProps} label="End date" />
                            </Box>
                            )}
                        />
                    </LocalizationProvider>
                    <img src={Images.CALENDAR} width="16" className="calenderIcon"/>
            </div>
            <button onClick={() => handleClickOpen("create")}>Schedule a Meeting</button>
            </div>
        </div>
        <div className="tabMainContainer">
        <TabContext value={value}>

          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Upcoming" value="1" />
            <Tab label="Previous" value="2" />
          </TabList>

          <TabPanel value="1">
            <UpcomingMeetings meetingsData={meetingsData} onCustomerLink={getCustomerLink} handleCloseMeetingMinutes={handleCloseMeetingMinutes} handleOpenMeatingMinutes={handleOpenMeatingMinutes} />
          </TabPanel>
          <TabPanel value="2">
            <PreviousMeetings meetingsData={previousData} onCustomerLink={getCustomerLink} handleCloseMeetingMinutes={handleCloseMeetingMinutes} handleOpenMeatingMinutes={handleOpenMeatingMinutes} />
          </TabPanel>
        </TabContext>
        </div>
      </div>
    </div>

  );
};

export default ScheduledMeetingList;
